import { Component, Input, OnChanges } from '@angular/core';
import * as Diff from 'diff';

@Component({
  selector: 'app-text-diff',
  template: `
    <b *ngIf="showTitle">{{titleNewText}}</b>
    <div [innerHTML]="newTextHighlighted"></div>
    <b *ngIf="showTitle">{{titleOldText}}</b>
    <div [innerHTML]="oldTextHighlighted"></div>
  `,
  styles: [`
    .simple-diff {
      display: flex;
      gap: 20px;
    }

    .diff-side {
      flex: 1;
      border: 1px solid #ddd;
      padding: 10px;
      border-radius: 4px;
    }

    ::ng-deep .deleted {
      background-color: #ffebee;
      color: #c62828;
      text-decoration: line-through;
    }

    ::ng-deep .added {
      background-color: #e8f5e8;
      color: #2e7d32;
      font-weight: bold;
    }

    ::ng-deep .unchanged {
      color: #666;
    }
  `]
})
export class TextDiffComponent implements OnChanges {

  @Input() oldText = '';
  @Input() newText = '';

  @Input() titleOldText = $localize`Ancien texte:`;
  @Input() titleNewText = $localize`Nouveau texte:`;

  @Input() showTitle = true;
  @Input() showOldOnly = false;
  @Input() showNewOnly = false;

  oldTextHighlighted = '';
  newTextHighlighted = '';

  ngOnChanges(): void {
    this.highlightDifferences();
  }

  private highlightDifferences(): void {
    const diff = Diff.diffWords(this.oldText || '', this.newText || '');

    let oldHtml = '';
    let newHtml = '';

    diff.forEach(part => {
      const text = part.value;

      if (part.removed) {
        oldHtml += `<span class="deleted">${this.escapeHtml(text)}</span>`;
      } else if (part.added) {
        newHtml += `<span class="added">${this.escapeHtml(text)}</span>`;
      } else {
        oldHtml += `<span class="unchanged">${this.escapeHtml(text)}</span>`;
        newHtml += `<span class="unchanged">${this.escapeHtml(text)}</span>`;
      }
    });

    this.oldTextHighlighted = oldHtml;
    this.newTextHighlighted = newHtml;
  }

  private escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
